import Config from '../config';
import { AxiosInstance } from '../helpers/AxiosInstance';
import { LoginType } from '../models/settings-model';


const getOrganizations = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/Organizations`);
};

const getOrganizationsGridData = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/Organizations/grid`);
};

const getOrganizationById = (orgId: string) => {
    return AxiosInstance.get(`${Config.API_URL}/api/Organizations/${orgId}`);
};

const updateOrganization = (data: any) => {
    return AxiosInstance.put(`${Config.API_URL}/api/Organizations`, data);
};

const createOrganization = (data: any) => {
    return AxiosInstance.post(`${Config.API_URL}/api/Organizations`, data);
};

const deleteOrganizations = (id: any) => {
    return AxiosInstance.delete(`${Config.API_URL}/api/Organizations/${id}`);
};

const GetNewOrganizationGridData = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/Organizations/new-grid`);
}

const GetNewOrganizationRechargeHistory = (id) => {
    return AxiosInstance.get(`${Config.API_URL}/api/Organizations/${id}/RechargeHistory`);
}

const GetNewOrganizationAccountDetails = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/Organizations/AccountDetails`);
}

const getSeatDetails = (id: string) => {
    return AxiosInstance.get(`${Config.API_URL}/api/Organizations/Plans/${id}`)
}

const getOrgPlanTrack = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/Organizations/OrgPlanTrack`)
}

const getOrganizationLoginType = (orgId: string) => {
    return AxiosInstance.get(`${Config.API_URL}/api/Organizations/SSOSetting/${orgId}`)
}

const updateOrganizationLoginType = (orgId: string, data: { ssoType: LoginType, ssoMandate: boolean }) => {
    return AxiosInstance.post(`${Config.API_URL}/api/Organizations/SSOSetting/${orgId}`, data)
}

export const OrganizationService = {
    getOrganizations,
    getOrganizationsGridData,
    getOrganizationById,
    updateOrganization,
    createOrganization,
    deleteOrganizations,
    GetNewOrganizationGridData,
    GetNewOrganizationRechargeHistory,
    GetNewOrganizationAccountDetails,
    getSeatDetails,
    getOrgPlanTrack,
    getOrganizationLoginType,
    updateOrganizationLoginType,
};








